module.exports = __webpack_public_path__ + "img/address.ceb06193.svg";